import * as React from 'react';
import { Control, useController } from 'react-hook-form';
import ControlledToggle, { ControlledToggleProps } from '../ControlledToggle';

export interface ToggleProps extends ControlledToggleProps {
  name: string;
  control?: Control;
}

const Toggle: React.FC<ToggleProps> = (props: ToggleProps) => {
  const { name, control, ...otherProps } = props;
  const {
    field: { value: valueProp, onChange },
  } = useController({
    name,
    control,
  });

  const onToggleChange = () => {
    onChange(!valueProp);
  };

  return (
    <ControlledToggle
      name={name}
      {...otherProps}
      value={valueProp}
      onChange={onToggleChange}
    />
  );
};

export default Toggle;
